<script setup lang="ts">
import {computed} from "vue"
import {DropdownButton, DropdownItem, ToggleSwitch} from "@hantera/design-system"
import type {AppSettingDefinitionInfo} from "@/backend/apps.types"

const props = defineProps<{
  modelValue: unknown
  definition: AppSettingDefinitionInfo
  settingKey: string
  readonly?: boolean
  hasStoredValue?: boolean
}>()

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void
}>()

const boolValue = computed(() => Boolean(props.modelValue))

const displayLabel = computed(() => {
  if (props.modelValue === true) return "True"
  if (props.modelValue === false) return "False"
  if (props.hasStoredValue) return "Secret value stored"
  return "Not set"
})
</script>

<template>
  <DropdownButton
    v-if="definition.secret"
    :label="displayLabel"
    :disabled="readonly ?? false"
  >
    <DropdownItem
      v-if="hasStoredValue && modelValue === undefined"
      disabled
    >
      Secret value stored
    </DropdownItem>
    <DropdownItem @click="emit('update:modelValue', true)">True</DropdownItem>
    <DropdownItem @click="emit('update:modelValue', false)">False</DropdownItem>
  </DropdownButton>

  <ToggleSwitch
    v-else
    :model-value="boolValue"
    :disabled="readonly"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
